import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHead = ({ profile, username }) => {
  if (!profile) return null;

  const title = profile.seo_title || `${profile.display_name || profile.username} - HubID Profile`;
  const description = profile.seo_description || profile.bio || `View ${profile.display_name || profile.username}'s Web3 identity on HubID`;
  const image = profile.avatar || `${window.location.origin}/og-default.png`;
  const url = `${window.location.origin}/#/u/${username}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="author" content={profile.display_name || profile.username} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="HubID" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {/* Additional Meta Tags */}
      <meta name="robots" content={profile.is_public ? "index, follow" : "noindex, nofollow"} />
      <link rel="canonical" href={url} />

      {/* Structured Data (JSON-LD) */}
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Person",
          "name": profile.display_name || profile.username,
          "description": profile.bio,
          "image": profile.avatar,
          "url": url,
          "sameAs": profile.wallet_address ? [`https://polygonscan.com/address/${profile.wallet_address}`] : [],
        })}
      </script>
    </Helmet>
  );
};

export default SEOHead;

